const config = {
  // Backend config
  apiGateway: {
    REGION: import.meta.env.REACT_APP_REGION!,
    URL: import.meta.env.REACT_APP_API_URL!,
  },
  cognito: {
    REGION: import.meta.env.REACT_APP_REGION!,
    USER_POOL_ID: import.meta.env.REACT_APP_USER_POOL_ID!,
    APP_CLIENT_ID: import.meta.env.REACT_APP_USER_POOL_CLIENT_ID!,
    IDENTITY_POOL_ID: import.meta.env.REACT_APP_IDENTITY_POOL_ID!,
  },
  app: {
    web_url: import.meta.env.REACT_APP_WEB_URL!,
    recaptcha_sitekey: import.meta.env.REACT_APP_RECAPTCHA_SITEKEY!,
    rum_app_monitor_id: import.meta.env.REACT_APP_RUM_APP_MONITOR_ID ?? '',
    rum_identity_pool_id: import.meta.env.REACT_APP_RUM_IDENTITY_POOL_ID ?? '',
    is_rum_enabled: import.meta.env.REACT_APP_RUM_ENABLED === 'true',
  },
};

export default config;
